import { frontendURL } from '../../../helper/URLHelper';
import SidebarAppView from './SidebarAppView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/sidebar-app/:appId'),
      name: 'sidebar_app',
      component: SidebarAppView,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
    },
  ],
};
